import { render, staticRenderFns } from "./notas.vue?vue&type=template&id=1e8aca7b&"
import script from "./notas.vue?vue&type=script&lang=js&"
export * from "./notas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports